export default "__VITE_ASSET__BUQAqOsK__"